export default __webpack_public_path__ + "static/no-image-ef2af602d5623e02718a48de457548e0.jpg";